import { render, staticRenderFns } from "./ClasseForm.vue?vue&type=template&id=a5172a8c&"
import script from "./ClasseForm.vue?vue&type=script&lang=js&"
export * from "./ClasseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports